export { akamaiImageLoader as default } from 'configs/imageLoader/imageLoader.ts'
